import { render, staticRenderFns } from "./statement_details.vue?vue&type=template&id=4b5832e7&scoped=true&"
import script from "./statement_details.vue?vue&type=script&lang=js&"
export * from "./statement_details.vue?vue&type=script&lang=js&"
import style0 from "./statement_details.vue?vue&type=style&index=0&id=4b5832e7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5832e7",
  null
  
)

export default component.exports